import React from 'react';
import { Form } from 'react-bootstrap';
const TechnicalTemplateField = _ref => {
  let {
    selectedTemplate,
    handleChange
  } = _ref;
  return /*#__PURE__*/React.createElement(Form.Check, {
    type: "checkbox",
    name: "include_technical_template",
    checked: selectedTemplate.include_technical_template,
    value: selectedTemplate.include_technical_template,
    onChange: handleChange,
    label: "Include Technical Template as an attachment"
  });
};
export default TechnicalTemplateField;